<div class="dialog-container">
  <h2 style="text-align: center;">Tutorial</h2>

  <video
    controls
    autoplay
    [src]="data.videoUrl"
    style="width: 100%; height: 100%; object-fit: contain;"
  ></video>

  <div class="actions">
    <button mat-flat-button color="primary" (click)="dialogRef.close()">Chiudi</button>
  </div>
</div>
